module.exports = __webpack_public_path__ + "img/compliance_background.2749447c.svg";